export default __webpack_public_path__ + "static/media/bull_opt.c46f4569.gif";